<template>
  <div class="flex h-full group">
    <div
      class="flex justify-center items-center overflow-y-auto transition-[width]
        duration-500 will-change-[width] w-1/2 group-[&:has(.forgot-password-sucess)]:w-0"
    >
      <div class="max-w-[450px] px-16 w-full text-center group-[&:has(.forgot-password-sucess)]:hidden">
        <h1 class="text-4xl font-semibold">{{ $route.meta.title }}</h1>
        <p class="mt-16 mb-32 text-sm" v-html="$route.meta.subtitle" />

        <router-view />
      </div>
    </div>

    <div
      class="bg-primary flex justify-center items-center flex-col gap-y-50 px-16
        transition-[width] duration-500 will-change-[width] w-1/2 group-[&:has(.forgot-password-sucess)]:w-full"
    >
      <LogoBigWhite class="max-w-[540px]" />

      <div :id="$portalNames.authTeleportHost" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $route } = useGlobalProperties()
</script>
